// @flow
import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { startSync, completeSync } from '../actions/app';
import useFirebase from './firebase';

const useApp = () => {
	const app = useSelector((state) => state.app);
	const dispatch = useDispatch();
	const [logEvent] = useFirebase();

	const startSyncCb = useCallback(() => {
		dispatch(startSync());
		logEvent('sync');
	}, [dispatch, logEvent]);

	const completeSyncCb = useCallback(() => dispatch(completeSync()), [dispatch]);

	return [app, startSyncCb, completeSyncCb];
};

export default useApp;
